





import { Component, Prop, Vue } from "vue-property-decorator"
import AppPrograma from "@/components/Programa/AppPrograma.vue";
import axios from 'axios'
import { Programa, testPrograma } from "@/Interfaces/Programa/Programa";

@Component({
  components: {
    AppPrograma,
  },
})
export default class WebTest extends Vue {
  @Prop({ default: false }) becario : boolean

  programa: Programa = null

  beforeCreate(){
    let programas = axios.get('//api.mundoconectado.org/api/v1/eventos/2/programaweb');
    return programas.then((respuesta) => {
      let programa = respuesta.data
      this.programa = programa
    })
  }
  mounted(){
    //console.log(JSON.stringify(this.programa));
  }
}
